import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import getLocale from '../../../i18n/getLocale';

class StaffGuaranteedHoursTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      staff_id: this.props.staff_id,
      code: null,
      hours: null,
      only_active: 1,
      staff_guaranteed_hours: [],
    };

    this.locale = getLocale();

    //bind específico
    this.add = this.add.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.refreshDataActive = this.refreshDataActive.bind(this);
    this.ativar = this.ativar.bind(this);
    this.desativar = this.desativar.bind(this);
    this.delete = this.delete.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(this.state.loaded === 0 && Array.isArray(newProps.staff_guaranteed_hours)) {
      this.setState({
        staff_guaranteed_hours: newProps.staff_guaranteed_hours,
        loaded: 1
      });
    }
  }

  // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      staff_id: this.state.staff_id,
      code: this.state.code,
      only_active: this.state.only_active,
      hours: this.state.hours,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcionario/horas/garantidas', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({ staff_guaranteed_hours: responseJson.data });
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Fetch ativando um item
  ativar(event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Tripulantes.EditarFuncionario.tabHorasGarantidas.ativar);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: id,
        only_active: this.state.only_active,
        staff_id: this.state.staff_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/funcionario/horas/garantidas/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ staff_guaranteed_hours: responseJson.data });
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Fetch deletando um item
  desativar(event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Tripulantes.EditarFuncionario.tabHorasGarantidas.arquivar);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: id,
        only_active: this.state.only_active,
        staff_id: this.state.staff_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/funcionario/horas/garantidas/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ staff_guaranteed_hours: responseJson.data });
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  refreshData (event) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcionario/horas/garantidas/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({staff_guaranteed_hours: responseJson.data, only_active: 0});
        }
        if(typeof event.message !== 'undefined') {
          self.props.handleAlert(event.message, event.status, 'open');
        } else {
          self.props.handleAlert("", "", 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  refreshDataActive (event) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/funcionario/horas/garantidas/ativas/' + self.state.staff_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({staff_guaranteed_hours: responseJson.data, only_active: 1});
        }
        if(typeof event.message !== 'undefined') {
          self.props.handleAlert(event.message, event.status, 'open');
        }else {
          self.props.handleAlert("", "", 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  delete($id) {
    var confirm = window.confirm(this.locale.Tripulantes.EditarFuncionario.tabHorasGarantidas.deletar);
    if (confirm) {
      var self = this;
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/funcionario/horas/garantidas/' + $id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.refreshData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">{this.locale.Tripulantes.EditarFuncionario.tabHorasGarantidas.tituloCentroDeCusto}</h3>
  <hr/>
  <button className="btn btn-sm btn-warning btn-block" onClick={self.state.only_active === 0 ? self.refreshDataActive.bind(self, self.state.staff_guaranteed_hours) : self.refreshData.bind(self, self.state.staff_guaranteed_hours)}>{self.state.only_active === 0 ? this.locale.Tripulantes.EditarFuncionario.tabHorasGarantidas.botaoEsconderArquivoMorto : this.locale.Tripulantes.EditarFuncionario.tabHorasGarantidas.botaoMostrarArquivoMorto}</button>
  <hr/>
  {(this.state.staff_guaranteed_hours === null || typeof this.state.staff_guaranteed_hours === 'undefined') ?  <div><small><em>Nenhuma horas garantidas cadastrado.</em></small><hr/></div>
  :
  <div>
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>
          <th className="text-center">{this.locale.Tripulantes.EditarFuncionario.tabHorasGarantidas.tabela.HorasGarantidasAdicional}</th>
          <th className="text-center">{this.locale.Tripulantes.EditarFuncionario.tabHorasGarantidas.tabela.Codigo}</th>
          <th className="text-center">{this.locale.Tripulantes.EditarFuncionario.tabHorasGarantidas.tabela.CadastradoEm}</th>
          <th className="text-center">{this.locale.Tripulantes.EditarFuncionario.tabHorasGarantidas.tabela.Status}</th>
          <th className="text-center">{this.locale.Tripulantes.EditarFuncionario.tabHorasGarantidas.tabela.Acoes}</th>
        </tr>
      </thead>
      <tbody id="suppliers-certifications">
        {Object.keys(self.state.staff_guaranteed_hours).map(function(k) {
          return (
            <tr>
              <td className="text-center">{self.state.staff_guaranteed_hours[k].hours}</td>
              <td className="text-center">{self.state.staff_guaranteed_hours[k].code}</td>
              <td className="text-center">{self.state.staff_guaranteed_hours[k].created_at_str}</td>
              <td className="text-center">{(self.state.staff_guaranteed_hours[k].active === 1) ?  <span className="label label-success">{self.locale.Tripulantes.EditarFuncionario.tabHorasGarantidas.tabela.Ativo}</span> : <span className="label label-danger">{self.locale.Tripulantes.EditarFuncionario.tabHorasGarantidas.tabela.Arquivado}</span>}</td>
              <td className="text-center">
                {(self.state.staff_guaranteed_hours[k].active === 1) ?
                  <button className="btn btn-sm btn-danger" value={self.state.staff_guaranteed_hours[k].id} onClick={self.desativar}><i className="fa fa-fw fa-power-off"></i></button>
                  :
                  <button className="btn btn-sm btn-success" value={self.state.staff_guaranteed_hours[k].id} onClick={self.ativar}><i className="fa fa-fw fa-power-off"></i></button>
                }
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
    <hr/>
  </div>
  }
  <h3 className="page-title">{this.locale.Tripulantes.EditarFuncionario.tabHorasGarantidas.tituloCadastrarHorasGarantidas}</h3>
  <hr/>
  <form onSubmit={this.add}>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabHorasGarantidas.formulario.HorasGarantidasAdicional}</label>
        <InputMask value={this.state.hours}  maskChar={null} name="hours" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'hours')} placeholder="" />
      </div>
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabHorasGarantidas.formulario.Codigo}:</label>
        <InputMask value={this.state.code}  maskChar={null} name="code" mask="999999999" className="form-control" onChange={this.handleChange.bind(this, 'code')} placeholder="" />
      </div>
    </div>
    <hr/>
    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Tripulantes.EditarFuncionario.tabHorasGarantidas.formulario.botaoSalvarHorasGarantidas}</button>
  </form>
</div>
    );
  }
}

export default StaffGuaranteedHoursTab;



// WEBPACK FOOTER //
// ./src/Components/Staffs/Elements/StaffGuaranteedHoursTab.js